import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { LinkyModule } from "../shared/util/linky/linky.module";
import { TmPipesModule } from "../shared/util/pipes";
import { BacklogListComponent } from "./backlog-list/backlog-list.component";
import { SavedFilterComponent } from "../filter/saved-filter/saved-filter.component";
import { TaskDetailsComponent } from "./task-details/task-details.component";
import { TmTaskbookModule } from "../taskbook-triage/taskbook-triage.module";
import { TaskActionsComponent } from "../taskbook-triage/task-actions/task-actions.component";
import { ThreadInputAreaComponent } from "@teammood/timeline";
import { TaskLastUpdateComponent } from "./task-last-update/task-last-update.component";
import { TaskDetailActionsComponent } from "./task-detail-actions/task-detail-actions.component";
import { ManagerCommentInputComponent } from "./manager-comment-input/manager-comment-input.component";
import { ReviewHistoryElementComponent } from "./review-history-element/review-history-element.component";
import { UsernameIconComponent } from "../shared/ui/username-icon/username-icon.component";
import { TaskbookBacklogComponent } from "./taskbook-backlog.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { ManagerCommentReviewComponent } from "./manager-comment-review/manager-comment-review.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MultiTaskLabelPopoverSelectorComponent } from "../taskbook-triage/task-label/multi-task-label-popover-selector copy/multi-task-label-popover-selector.component";
import { TaskLabelsComponent } from "./task-details/task-labels/task-labels.component";
import { MatChipRemove, MatChipRow } from "@angular/material/chips";
import { MatIcon } from "@angular/material/icon";
import { MultiTaskAssigneePopoverSelectorComponent } from "../taskbook-triage/task-assignee/multi-task-assignee-selector/multi-task-assignee-selector.component";

@NgModule({
    declarations: [
        TaskbookBacklogComponent,
        BacklogListComponent,
        TaskDetailsComponent,
        TaskLastUpdateComponent,
        ReviewHistoryElementComponent,
        ManagerCommentReviewComponent,
        TaskLabelsComponent
    ],
    imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LinkyModule,
    TmPipesModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    RouterLink,
    SavedFilterComponent,
    TmTaskbookModule,
    TaskActionsComponent,
    ThreadInputAreaComponent,
    TaskDetailActionsComponent,
    ManagerCommentInputComponent,
    UsernameIconComponent,
    MatProgressBarModule,
    MultiTaskLabelPopoverSelectorComponent,
    MatChipRemove,
    MatChipRow,
    MatIcon,
    MultiTaskAssigneePopoverSelectorComponent
]
})
  export class TmTaskbookBacklogModule{
  }